import LoyaltyIcon from "@material-ui/icons/Loyalty";
import { token } from "functions/Helper";
import CreateMerchantPromo from "views/MerchantPromo/CreateMerchantPromo";
import EditMerchantPromo from "views/MerchantPromo/EditMerchantPromo";
import MerchantPromo from "views/MerchantPromo/MerchantPromo";
import MerchantPromoDetail from "views/MerchantPromo/MerchantPromoDetail";
import RemoveBanner from "views/MerchantPromo/RemoveBanner";
import RemovePartnerLogo from "views/MerchantPromo/RemovePartnerLogo";
import UploadBanner from "views/MerchantPromo/UploadBanner";
import UploadLogo from "views/MerchantPromo/UploadLogo";

const merchantPromo = () => {
  let views = [];

  if (
    token["booking.merchant_promos.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantPromo/List",
      name: "M Promo",
      icon: LoyaltyIcon,
      component: MerchantPromo,
      layout: "/admin"
    });
  }

  return views;
};

const merchantPromoHidden = () => {
  let views = [];

  if (
    token["booking.merchant_promos.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantPromo/Detail",
      name: "Merchant Promo Detail",
      component: MerchantPromoDetail,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["booking.merchant_promos.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/MerchantPromo/Create",
        name: "Create Merchant Promo",
        component: CreateMerchantPromo,
        layout: "/admin"
      },

      {
        path: "/MerchantPromo/Edit",
        name: "Edit Merchant Promo",
        component: EditMerchantPromo,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantPromo/UploadBanner",
        name: "Upload Banner Merchant Promo",
        component: UploadBanner,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantPromo/RemoveBanner",
        name: "Remove Banner Merchant Promo",
        component: RemoveBanner,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantPromo/UploadPartnerLogo",
        name: "Upload Partner Logo Merchant Promo",
        component: UploadLogo,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantPromo/RemovePartnerLogo",
        name: "Remove Partner Logo Merchant Promo",
        component: RemovePartnerLogo,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Merchant Promo Hidden",
        state: "merchantPromoHidden",
        hideInSidebar: true,
        views: views
      }
    ];

  return [];
};

export { merchantPromo, merchantPromoHidden };
